/**
 * Timing and geometry for the Checkout morph: the service popup fades out (200ms), then the
 * booking form's components are placed instantly at the dialog center and animate into place
 * (400ms, lightly staggered). All of it is skipped under prefers-reduced-motion.
 */
export class CheckoutMorph {
    static FADE_MS = 200;
    static MOVE_MS = 400;
    static STAGGER_MS = 40;
    static MAX_STAGGER_MS = 240;
    /** Router state carried by the Checkout navigation. */
    static ROUTE_STATE = { morph: "center" };
    static shouldAnimate(reducedMotion) {
        return !reducedMotion;
    }
    /** Popup side: when to start fading and when to hand off to the form route. */
    static schedule(reducedMotion) {
        if (reducedMotion)
            return [{ at: 0, phase: "navigate" }];
        return [
            { at: 0, phase: "out" },
            { at: CheckoutMorph.FADE_MS, phase: "navigate" },
        ];
    }
    /** Translation that puts an item's center on the dialog's center. */
    static centerOffset(item, dialog) {
        return {
            dx: dialog.left + dialog.width / 2 - (item.left + item.width / 2),
            dy: dialog.top + dialog.height / 2 - (item.top + item.height / 2),
        };
    }
    /** Popup translation: runs in parallel with the fade, same duration. */
    static TRANSLATE_MS = CheckoutMorph.FADE_MS;
    static TRANSLATE_EASING = "ease";
    /** Move from the Checkout button's center toward the viewport center. */
    static translationToCenter(button, viewport) {
        const dx = viewport.width / 2 - (button.left + button.width / 2);
        const dy = viewport.height / 2 - (button.top + button.height / 2);
        return { dx: dx + 0, dy: dy + 0 };
    }
    /** Inline CSS variables for the popup panel transform; empty when motion is reduced. */
    static translationStyle(t, reducedMotion) {
        if (reducedMotion)
            return {};
        return { "--cd-morph-dx": `${t.dx}px`, "--cd-morph-dy": `${t.dy}px` };
    }
    static delayFor(index) {
        return Math.min(Math.max(0, index) * CheckoutMorph.STAGGER_MS, CheckoutMorph.MAX_STAGGER_MS);
    }
    /** How long until the last of `count` items has settled. */
    static totalMs(count) {
        return count <= 0 ? 0 : CheckoutMorph.MOVE_MS + CheckoutMorph.delayFor(count - 1);
    }
    static isRequested(state) {
        return (typeof state === "object" &&
            state !== null &&
            state.morph === CheckoutMorph.ROUTE_STATE.morph);
    }
}
//# sourceMappingURL=CheckoutMorph.js.map